import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import DeleteModal from "../../../components/Common/DeleteModal";
import { usePagination } from "../../../hooks/usePagination";
import ResultHandler from "../../../components/ResultHandler";
import PaginationHandler from "../../../components/PaginationHandler";
import {
  deleteEmployee,
  getEmployees,
  searchAndExport,
  importFile,
  importEmployees,
} from "../../../api/employees";
import TableHeaderHandler from "../../../components/TableHeaderHandler";
import { useTranslation } from "react-i18next";
import { useResponse } from "../../../hooks/useResponse";
import TableAction from "../../../components/TableAction";
import EmptyData from "../../../components/EmptyData";
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
  AccordionItem,
  Button,
  Col,
  Modal,
  ModalBody,
  Row,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
} from "reactstrap";

import { PERMISSIONS } from "../../../api/permissions";
import ImportModal from "../../../components/ImportModal";
import AssignAdminModal from "./AssignAdminModal";
import TableFilter from "../../../components/TableFilter";

const parseAction = ({ action, admin }) => {
  return `${admin.username} has ${action}${
    action[action.length - 1] === "e" ? "d" : "ed"
  } an employee (${admin.role.name})`;
};
const getClassByEmployeeHistoryAction = (action) => {
  switch (action) {
    case "import": {
      return "badge bg-info";
    }
    case "create": {
      return "badge bg-success";
    }
    case "edit": {
      return "badge bg-warning";
    }
  }
};

export default function EmployeesTable() {
  const { t } = useTranslation();

  const navigate = useHistory();

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,
    setMeta,
  } = usePagination(getEmployees);

  // Filter
  const filterTypes = [
    { key: "name", type: "text" },
    { key: "email", type: "email" },
  ];

  //// delete
  const [show, setShow] = useState(false);
  const [deletingEmployee, setDeletingEmployee] = useState(null);

  const { setData } = useResponse(deleteEmployee, () => {
    setShow(false);
    setDeletingEmployee(null);
    setPayload({});
  });

  function onDeleteClick() {
    setData({ type: "add", data: deletingEmployee });
  }

  function onCloseClick() {
    setShow(false);
  }

  ///// import

  const [importModalOpen, setImportModalOpen] = useState(false);

  //// assign

  const [selectedEmployee, setSelectedEmployee] = useState(null);

  return (
    <>
      <TableHeaderHandler
        permission={PERMISSIONS.EMPLOYEE_CREATE}
        setPage={setPage}
        setPerPage={setPerPage}
        addUrl="/add-employee"
      >
        <div style={{ marginRight: "15px" }}>
          <Button onClick={() => setImportModalOpen(true)} color="info">
            Import
          </Button>
        </div>
      </TableHeaderHandler>

      <TableFilter
        filterTypes={filterTypes}
        onFilter={(filters) => setMeta({ page: 1, payload: filters })}
      />

      <div className="table-rep-plugin">
        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th>Name</Th>
                <Th>Email</Th>
                <Th>Gender</Th>
                <Th>Price Components</Th>
                <Th style={{ width: "15%" }}>{t("tables.Action")}</Th>
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.employees.map((row) => {
                  return (
                    <Tr key={row.id}>
                      <Td
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate.push("/employees/" + row.id)}
                      >
                        {row.name}
                        <Button
                          style={{ display: "block" }}
                          size="sm"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedEmployee(row);
                          }}
                          color="dark"
                        >
                          {row.admins.length == 0
                            ? "Assign Admin"
                            : row.admins[0].username}
                        </Button>
                      </Td>
                      <Td>{row.email}</Td>
                      <Td className="text-capitalize">{row.gender}</Td>
                      <Td>
                        <Button
                          size="sm"
                          color="dark"
                          onClick={() =>
                            navigate.push(
                              "/employees/" + row.id + "/price-components"
                            )
                          }
                        >
                          view
                        </Button>
                      </Td>
                      <Td>
                        <TableAction
                          hasEdit={true}
                          hasDelete={true}
                          editPermission={PERMISSIONS.EMPLOYEE_EDIT}
                          deletePermission={PERMISSIONS.EMPLOYEE_DELETE}
                          type="employee"
                          id={row.id}
                          setShow={setShow}
                          setDeleteIntitiy={setDeletingEmployee}
                        />
                        <Button
                          style={{ marginLeft: "5px" }}
                          color="dark"
                          onClick={() => navigate.push("employees/" + row.id)}
                        >
                          <i className="bx bxs-show font-size-16 align-middle" />
                        </Button>
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            )}
          </Table>

          {!loading && (
            <EmptyData
              empty={response.data && response.data.employees.length === 0}
              msg="No Employees Found."
            />
          )}
          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />

          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}

          <ImportModal
            isOpen={importModalOpen}
            onCloseClick={() => {
              setImportModalOpen(false);
            }}
            api={importEmployees}
            handleRefresh={() => setPayload({ refresh: true })}
            fileName="erp_import_employees_template.xlsx"
          />

          <AssignAdminModal
            isOpen={selectedEmployee ? true : false}
            employee={selectedEmployee}
            handleClose={() => setSelectedEmployee(null)}
            hnadleRefresh={() => setPayload({ refetch: true })}
          />

          <ResultHandler error={error} loading={loading} />
        </div>
      </div>
    </>
  );
}
